/**
 * Client-side user event names — must match server/utils/user-events.ts whitelist.
 */
export type UserEventName =
  | 'product_analytics.page_viewed'
  | 'product_analytics.sku_selected'
  | 'product_analytics.fiscal_year_changed'
  | 'product_analytics.tab_changed'
  | 'product_analytics.society_view_changed'
  | 'product_analytics.drilldown_opened';

export type UserEventPage = 'product_analytics';

export interface UserEventPayload {
  event: UserEventName;
  page: UserEventPage;
  metadata?: Record<string, string>;
}

export const PAGE_BY_EVENT: Record<UserEventName, UserEventPage> = {
  'product_analytics.page_viewed': 'product_analytics',
  'product_analytics.sku_selected': 'product_analytics',
  'product_analytics.fiscal_year_changed': 'product_analytics',
  'product_analytics.tab_changed': 'product_analytics',
  'product_analytics.society_view_changed': 'product_analytics',
  'product_analytics.drilldown_opened': 'product_analytics',
};
